<template>
  <div>
    <!-- Alert errori -->
    <div v-if="errors" class="alert alert-danger alert-dismissible fade show" role="alert">
      <ul class="mb-0">
        <li v-for="(msg, field) in errors" :key="field">{{ msg[0] }}</li>
      </ul>
      <button type="button" class="btn-close" @click="$emit('update:errors', null)"></button>
    </div>

    <!-- Alert successo -->
    <div v-if="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
      {{ successMessage }}
      <button type="button" class="btn-close" @click="$emit('update:successMessage', null)"></button>
    </div>

    <form @submit.prevent="submitForm" class="needs-validation">
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label">Data / Ora</label>
          <input type="datetime-local" class="form-control" v-model="formData.date" :min="minDateTime" required>
        </div>
        <div class="col-md-6">
          <label class="form-label">Tipologia</label>
          <select class="form-select" v-model="formData.type">
            <option value="tematica">Tematica</option>
            <option value="generica">Generica</option>
          </select>
        </div>
        <div class="col-md-12">
          <label class="form-label">Oggetto</label>
          <input type="text" class="form-control" v-model="formData.object" required>
        </div>
        <div class="col-md-12">
          <label class="form-label">Link</label>
          <input type="text" class="form-control" v-model="formData.conference_link">
        </div>
        <div class="col-md-12">
          <label class="form-label">Descrizione</label>
          <textarea class="form-control" rows="4" v-model="formData.description"></textarea>
        </div>

        <div class="col-12 mt-3 d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">Annulla</button>
          <button type="submit" class="btn btn-primary" :disabled="!canSave">Salva</button>
          <!--<button v-if="formData.id" type="button" class="btn btn-danger" @click="deleteUoc">Elimina</button>-->
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'UocForm',
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        id: null,
        date: '',
        type: 'generica',
        object: '',
        description: ''
      })
    },
    errors: { type: Object, default: null },
    successMessage: { type: String, default: null }
  },
  computed: {
    minDateTime() {
      const now = new Date();

      const pad = n => String(n).padStart(2, '0');

      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}`;
    },
    formData: {
      get() {
        return this.modelValue || { id: null, date: '', type: 'generica', object: '', description: '' };
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    },
    canSave() {
      if (!this.formData.date || !this.formData.object || !this.formData.type) {
        return false;
      }

      const selectedDate = new Date(this.formData.date);
      const now = new Date();

      return selectedDate >= now;
    }
  },
  methods: {
    async submitForm() {
      if (!this.canSave) return;
      this.$emit('save', this.formData);
    },
    async deleteUoc() {
      this.$emit('delete', this.formData);
    }
  }
}
</script>

<style scoped>
textarea.form-control {
  min-height: 80px;
}
</style>
